import React, { useState } from 'react';
import { associateStoresToInvoicesByCsvMutation } from '../../graphql/mutations';
import { useMutation } from '@apollo/client';
import { Button, FormText } from 'reactstrap';

export function LinkInvoicesWithStores() {
  const defaultCsv = `billomat_invoice_id;store_id
12345;str_xxx`;

  const [associateStoresToInvoicesByCsv, { loading, error }] = useMutation(
    associateStoresToInvoicesByCsvMutation,
  );
  const [csvInput, setCsvInput] = useState(defaultCsv);

  const submit = async () => {
    try {
      await associateStoresToInvoicesByCsv({
        variables: {
          csvInput: csvInput,
        },
      });
    } catch (e) {
      alert('Error: ' + e);
    }
  };

  return (
    <div>
      <textarea
        className="form-control"
        value={csvInput}
        spellCheck={false}
        onChange={(e) => setCsvInput(e.target.value)}
        rows={5}
        style={{ minWidth: '100%' }}
      />
      <FormText color="muted">
        30 lines max. Semicolon is required as a seperator
      </FormText>
      <br />
      {error && error.graphQLErrors && <p>{error.graphQLErrors.join()}</p>}
      <Button onClick={submit} disabled={loading}>
        {loading ? 'updating...' : 'Associate invoices to stores'}
      </Button>
    </div>
  );
}
